import T6 from '../../components/ExcerciseTypes/TypeIn/T6'
import Circle_Write from '../../components/ExcerciseTypes/Circle_Write'
import T6v2 from '../../components/ExcerciseTypes/TypeIn/T6v2'
import DesignUnderLine from "../../components/ExcerciseTypes/Design/DesignUnderLine";
const json = {
	1: {
		unit: 'Unit 2',
		id: 'FP8-WB-demo-2023-U1-P17-E1',
		audio: '',
		video: '',
		// recorder: true,
		exerciseKey: '/img/FriendsPlus/Page17/Key/E1answerKey.jpg',
		component: T6,
		inputSize: 105,
		isHiddenCheck:true,
		stylesTextInput: {
			background: "transparent",
			border: "none",
			borderBottom: "1px solid gray",
			fontSize: "24px",
			textAlign: "center",
		  },
		titleQuestion: [
			{
				num: '1',
				title: `Complete the table with the words.`,
				color: 'rgb(29,193,224)',
				star:1
			},
		],
		questionImage: [],
		// hideBtnFooter: true,
		questions: [
			{
				title: `
				<div style='margin-top: 20px; display: flex; gap: 30px;max-width:490px;margin-left:180px;margin-bottom:20px'>
				<div style='flex: 1; border-radius: 20px; padding: 20px 30px; border: 3px solid rgb(29,193,224);'>
				  <div><span style="margin-right:20px">been</span><span style="margin-right:20px;">ever</span><span style="margin-right:20px">finished</span><span style="margin-right:20px">has</span><span style="margin-right:20px">hasn't</span><span style="text-decoration:line-through">have</span></div>
				  <div><span style="margin-right:20px;margin-left:80px">haven't</span><span style="margin-right:20px;margin-left:10px">he</span><span style="margin-right:20px;margin-left:10px">made</span><span style="">you</span></div>
				  
				</div>
				
			  </div>
		
				<div style='position: relative;'>
				  <div><img src='img/FriendsPlus/Page17/E1/1.jpg' width='100%' /></div>
				  <div style='position: absolute; top: 126px; left: 320px;'>#</div>
				  <div style='position: absolute; top: 122px; left: 563px;'>#</div>
				  <div style='position: absolute; top: 164px; left: 563px;'>#</div>
				  <div style='position: absolute; top: 222px; left: 52px;'>#</div>
				  <div style='position: absolute; top: 222px; left: 286px;'>#</div>
				  <div style='position: absolute; top: 222px; left: 562px;'>#</div>
				  <div style='position: absolute; top: 334px; left: 360px;'>#</div>
				  <div style='position: absolute; top: 435px; left: 332px;'>#</div>
				  <div style='position: absolute; top: 478px; left: 403px;'>#</div>
		
				  
		
				  
				  
				</div>
			  </div>
        `,
				answer: ["you", "been", "made", "Has", "he", "finished", 
					"ever", "haven't", "hasn't"],
			},
		],
	},
	2: {
		unit: "Unit 2",
		id: "FP8-WB-demo-2023-U2-P17-E2",
		audio: "",
		video: "",
		// recorder: true,
		exerciseKey: "/img/FriendsPlus/Page17/Key/E2answerKey.jpg",
		component: T6v2,
		// maxLength: 6,
		inputSize: 180,
		stylesTextInput: {
		  background: "transparent",
		  border: "none",
		  borderBottom: "1px solid gray",
		  fontSize: "24px",
		  textAlign: "center",
		},
		titleQuestion: [
		  {
			num: "2",
			title: `
			Complete the online chat using the 
correct present perfect form of the verbs.`,
			color: "rgb(29,193,224)",
			star:2
		  },
		],
		questionImage: [],
		// hideBtnFooter: true,
		isHiddenCheck: true,
		questions: [
		  {
			title: `
			<div style='margin-top: 20px; display: flex; gap: 30px;max-width:490px;margin-left:100px;margin-bottom:20px'>
			<div style='flex: 1; border-radius: 20px; padding: 20px 30px; border: 3px solid rgb(29,193,224);'>
			  <div><span style="margin-right:20px;text-decoration:line-through">amazing</span><span style="margin-right:20px;">delicious</span><span style="margin-right:20px">disgusting</span><span>exhausted</span></div>
			  <div><span style="margin-right:20px;margin-left:120px">fascinating</span><span style="">wonderful</span></div>
			  
			</div>
			
		  </div>
	
			<div style='position: relative;'>
			  <div><img src='img/FriendsPlus/Page17/E2/1.jpg' width='100%' /></div>
			  <div style='position: absolute; top: 305px; left: 238px;'>#</div>
			  <div style='position: absolute; top: 428px; left: 78px;'>#</div>
			  <div style='position: absolute; top: 428px; left: 432px;'>#</div>
			  <div style='position: absolute; top: 548px; left: 156px;'>#</div>
			  <div style='position: absolute; top: 630px; left: 77px;'>#</div>
			  <div style='position: absolute; top: 630px; left: 325px;'>#</div>
			  <div style='position: absolute; top: 750px; left: 180px;'>#</div>
			  <div style='position: absolute; top: 750px; left: 406px;'>#</div>
			  <div style='position: absolute; top: 790px; left: 134px;'>#</div>
			  <div style='position: absolute; top: 790px; left: 410px;'>#</div>
			  <div style='position: absolute; top: 917px; left: 277px;'>#</div>
			  <div style='position: absolute; top: 917px; left: 525px;'>#</div>
			  <div style='position: absolute; top: 1031px; left: 152px;'>#</div>
			  <div style='position: absolute; top: 1031px; left: 422px;'>#</div>
			  <div style='position: absolute; top: 1071px; left: 62px;'>#</div>
	
			  
	
			  
			  
			</div>
		  </div>
			`,
			answer: ["’s happened", "Has","finished", "hasn't", 
				"Have","got", "have" ,"'ve passed", "'ve", "done" ,
				"Have","celebrated", "have","'ve", "been"],
		  },
		],
	  },
	3: {
		unit: 'Unit 2',
		id: 'FP8-WB-demo-2023-U1-P17-E3',
		audio: '',
		video: '',
		// recorder: true,
		exerciseKey: '/img/FriendsPlus/Page17/Key/E3answerKey.jpg',
		component: T6,
		inputSize: 170,
		titleQuestion: [
			{
				num: '3',
				title: `Correct the words.`,
				color: 'rgb(29,193,224)',
				star:2
			},
		],
		questionImage: [],
		questions: [
			{
				title: `
            <div>
			<dib><span style="text-decoration:line-through"><b>Did</b></span> you ever ridden an elephant? <span style="font-weight:bold;margin-left:20px">Have</span></div>
				<div><strong style="margin-right:15px">1</strong>She’s never <b>ate</b> Greek food.# </div>
				<div><strong style="margin-right:15px">2</strong><b>Katy gone</b> to the beach.# </div>
				<div><strong style="margin-right:15px">3</strong>I’<b>ve left</b> my phone at home yesterday. # </div>
				<div><strong style="margin-right:15px">4</strong>We <b>didn’t see</b> Max since last year. # </div>
				<div><strong style="margin-right:15px">5</strong>‘<b>Have</b> you like the show?’ ‘Yes!’  # </div>
			</div>
        `,
				answer: [
					"eaten", "Katy's gone", "left", "haven't seen", "Did"
				],
			},
		],
	},
	4: {
		unit: 'Unit 2',
		id: 'FP8-WB-demo-2023-U1-P17-E4',
		audio: '',
		video: '',
		exerciseKey: '/img/FriendsPlus/Page17/Key/E4answerKey.jpg',
		component: T6,
		inputSize:'300px',
		titleQuestion: [
			{
				num: '4',
				title: `Complete the mini-dialogues with the 
				present perfect or past simple form of the verbs 
				in brackets.`,
				color: 'rgb(29,193,224)',
				star:2
			},
		],
		textareaStyle: { width: 400 },
		// hideBtnFooter: true,
		questions: [
			{
				title: `
              <div>
			  <div><strong style="margin-right:15px">A</strong><b>Have you ever been</b> (you / go) to Brazil? </div>
			  <div><strong style="margin-right:15px">B</strong>Yes, I <b>have</b> . I <b>went</b> (go) there 
			  <div><strong style="margin-right:15px">1</strong><b style="margin-right:15px">A</b>We # (never see) a wild tiger. </div>
			  <div><strong style="margin-right:15px;margin-left:30px">B</strong>I # ! I # (see) one last year in India.</div>
			  <div><strong style="margin-right:15px">2</strong><b style="margin-right:15px">A</b> I # (enjoy) that film yesterday. </div>
			  <div><strong style="margin-right:15px;margin-left:30px">B</strong>I # (not). I # (read) 
			  the book last year and it was better.</div>
			  <div><strong style="margin-right:15px">3</strong><b style="margin-right:15px">A</b># (he / tell) you the news? </div>
			  <div><strong style="margin-right:15px;margin-left:30px">B</strong>Yes #,. He # (talk) to 
			  me last night.</div>
			  <div><strong style="margin-right:15px">4</strong><b style="margin-right:15px">A</b># (they / ever / try) sushi? </div>
			  <div><strong style="margin-right:15px;margin-left:30px">B</strong> No, # (not). They hate fish.
			  </div>
			  </div>
        `,
				answer: ["'ve never seen", "have", "saw",
					"enjoyed", "didn't", "read",
					"Has he told", "he has", "talked",
					"Have they ever tried", "they haven't" ],
			},
		],
	},
	5: {
		unit: 'Unit 2',
		id: 'FP8-WB-demo-2023-U1-P17-E5',
		audio: '',
		video: '',
		inputSize: 605,
		component: T6,
		titleQuestion: [
			{
				num: '5',
				title: `CWrite questions using the present 
				perfect or past simple. Then write answers that 
				are true for you.`,
				color: 'rgb(29,193,224)',
				star:3
			},
		],
		textareaStyle: { width: 600 },
		// hideBtnFooter: true,
		questions: [
			{
				title: `
              <div>
				<div>you / ever / go / abroad ?</div>
				<div><b>Have you ever been abroad?<br>
				Yes, I have. I’ve been to Italy and Poland.</b></div>
				<div><strong style="margin-right:15px">1</strong>your parents / ever / live / in a different town ?</div>
				<div>#</div>
				<div>#</div>
				<div><strong style="margin-right:15px">2</strong>you / go / on holiday / last summer ?</div>
				<div>#</div>
				<div>#</div>
				<div><strong style="margin-right:15px">3</strong>you / eat / tasty meal / in the last week ?</div>
				<div>#</div>
				<div>#</div>
				<div><strong style="margin-right:15px">4</strong>you / read / good books / recently ? </div>
				<div>#</div>
				<div>#</div>
			  </div>
        `,
				answer: ["Have your parents ever lived in a different town?",
					"",
					"Did you go on holiday last summer?",
					"",
					"Have you eaten a tasty meal in the last week?",
					"",
					"Have you read any good books recently?",
					""],
			},
		],
	},
}

export default json
